// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomUpload = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '14',
      height: '14',
      viewBox: '0 0 14 14',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.9261 8.17571C7.2199 8.17571 7.45721 7.93841 7.45721 7.6559V2.22614L7.412 1.38993L7.76231 1.80239L8.55333 2.64425C8.64373 2.74595 8.77368 2.79681 8.90363 2.79681C9.16354 2.79681 9.37824 2.61035 9.37824 2.3448C9.37824 2.20354 9.32174 2.10184 9.22569 2.00579L7.3329 0.180804C7.19165 0.0452009 7.06735 0 6.9261 0C6.79049 0 6.66054 0.0452009 6.52494 0.180804L4.6265 2.00579C4.53045 2.10184 4.4796 2.20354 4.4796 2.3448C4.4796 2.61035 4.68865 2.79681 4.94856 2.79681C5.07851 2.79681 5.21411 2.74595 5.30451 2.64425L6.08988 1.80239L6.44019 1.38428L6.40063 2.22614V7.6559C6.40063 7.93841 6.63794 8.17571 6.9261 8.17571ZM2.0896 13.3173H11.7569C12.983 13.3173 13.6215 12.6845 13.6215 11.4754V8.15876C13.6215 7.55985 13.565 7.23214 13.2768 6.88749L11.6326 4.86475C10.8812 3.94378 10.5987 3.72342 9.5647 3.72342H8.50248V4.66134H9.59295C9.98281 4.66134 10.2314 4.74044 10.5535 5.13595L12.2994 7.29994C12.4971 7.5542 12.418 7.66155 12.1298 7.66155H8.58723C8.29342 7.66155 8.15782 7.87061 8.15782 8.09096V8.11356C8.15782 8.72377 7.68321 9.37354 6.9261 9.37354C6.16333 9.37354 5.68872 8.72377 5.68872 8.11356V8.09096C5.68872 7.87061 5.55877 7.66155 5.25931 7.66155H1.72234C1.42854 7.66155 1.36639 7.53725 1.55284 7.29994L3.28742 5.1529C3.62078 4.74609 3.86373 4.66134 4.25924 4.66134H5.34971V3.72342H4.28749C3.25352 3.72342 2.97667 3.93813 2.20825 4.87605L0.56972 6.88749C0.292864 7.22649 0.230713 7.55985 0.230713 8.15876V11.4754C0.230713 12.6845 0.869175 13.3173 2.0896 13.3173ZM2.1461 12.1873C1.62629 12.1873 1.34378 11.9161 1.34378 11.3737V8.65597H4.7282C4.90901 9.66169 5.78477 10.4075 6.9261 10.4075C8.06742 10.4075 8.94318 9.66169 9.12399 8.65597H12.5084V11.3737C12.5084 11.9161 12.2202 12.1873 11.7004 12.1873H2.1461Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomUpload };
